var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDashboardActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 23,
  viewBox: "0 0 24 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.13256 5C7.11616 5.42145 6.2015 6.03867 5.43554 6.80462C3.93074 8.30944 3 10.3883 3 12.6845C3 17.277 6.72296 21 11.3155 21C13.6117 21 15.6906 20.0692 17.1954 18.5644C17.9614 17.7985 18.5786 16.8838 19 15.8674",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12H20C20 7.58172 16.4183 4 12 4V12Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDashboardActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_dashboard_active.8bb475f0c868c16a5d0ceee5d3ab390f.svg";